import { MergeUserSettings } from './mutationTypes'

const mutations = {
  /**
   * Update settings by merging
   * both settings objects
   *
   * @param {array}
   */
  [MergeUserSettings](state, settings) {
    state.settings = { ...state.settings, ...settings }
  },
}

export default mutations
